
//TODO shrink header on scroll.

$(window).scroll(function () {
    clearTimeout($.data(this, 'scrollTimer'));

    //Check if the page is scrolled and change the padding on the header.
    $.data(this, 'scrollTimer', setTimeout(function () {
        var $header = $(".main-header");
        var offsetTop = $header.offset().top;

        if (offsetTop > 50) {
            $header.addClass("scrolled");
        } else {
            $header.removeClass("scrolled");
        }
    }, 0)); //Change this number to improve performance - the animation will be delayed.

});

// Toggle search

$('.search-form__trigger').on("click",
    function () {
        $('.main-header').find('.search-form').toggleClass("active").parents(".main-header__end").first().toggleClass("active");
        $('.main-header').find('.search-form__input').focus();

        if ($('.main-header').find('.search-form').hasClass("active")) {
            $('.main-header__logo-image--mobile').css('opacity', '0');
            $('.only-mobile-menu').find('.main-header__logo').css('opacity', '0');
        } else {
            $('.main-header__logo-image--mobile').css('opacity', '1');
            $('.only-mobile-menu').find('.main-header__logo').css('opacity', '1');
        }

        $(this).toggleClass("active");
    });
